define("settings/templates/subscription/cancel", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f

  var _default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.showSuccessModal}}
    <CancelPlan::Modal::Success @onClose={{this.exitCancellationFlow}} />
  {{else}}
    <CancelPlan::Wizard @exitCancellationFlow={{this.exitCancellationFlow}} />
  {{/if}}
  */
  {
    "id": "KB5QZMar",
    "block": "[[[41,[30,0,[\"showSuccessModal\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@onClose\"],[[30,0,[\"exitCancellationFlow\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,2],null,[[\"@exitCancellationFlow\"],[[30,0,[\"exitCancellationFlow\"]]]],null],[1,\"\\n\"]],[]]]],[],false,[\"if\",\"cancel-plan/modal/success\",\"cancel-plan/wizard\"]]",
    "moduleName": "settings/templates/subscription/cancel.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});